// 15.G: общий хук разметки заказчика по находкам проверки. Параллель «разметке
// эталона» Комплектности (CompletenessPanel), но плоская карта по finding_id и
// единый набор полей: позиция заказчика (agree|disagree|clarify) + стр. + коммент.
// Автосохранение с дебаунсом 800мс, без кнопки «Сохранить».
import { useState, useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export type MarkupLabel = { verdict: string; page: string; comment: string };
export type MarkupCheck = 'task' | 'decisions' | 'norms';

export function useMarkup(projectId: string, check: MarkupCheck) {
  const [markupMode, setMarkupMode] = useState(false);
  const [labels, setLabels] = useState<Record<string, MarkupLabel>>({});
  const [savedAt, setSavedAt] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const q = useQuery<{ labels: Record<string, { verdict?: string; page?: number | string | null; comment?: string }> }>({
    queryKey: ['markup-labels', projectId, check],
    queryFn: () => api.get(`/projects/${projectId}/markup/${check}/labels`),
    enabled: markupMode,
  });
  useEffect(() => {
    const m = q.data?.labels;
    if (!m) return;
    const flat: Record<string, MarkupLabel> = {};
    for (const [id, l] of Object.entries(m)) {
      flat[id] = { verdict: l.verdict || '', page: l.page != null ? String(l.page) : '', comment: l.comment || '' };
    }
    setLabels(flat);
  }, [q.data]);

  const saveAll = (current: Record<string, MarkupLabel>) => {
    const payload: Record<string, { verdict: string | null; page: number | null; comment: string }> = {};
    for (const [id, l] of Object.entries(current)) {
      if (!l.verdict && !l.page && !l.comment) continue;   // пустые не храним
      payload[id] = { verdict: l.verdict || null, page: l.page ? Number(l.page) : null, comment: l.comment || '' };
    }
    api.post(`/projects/${projectId}/markup/${check}/labels`, { labels: payload })
      .then(() => setSavedAt(new Date().toLocaleTimeString('ru-RU')))
      .catch(() => {});
  };

  const setLabel = (id: string, patch: Partial<MarkupLabel>) => {
    setLabels((prev) => {
      const base = prev[id] || { verdict: '', page: '', comment: '' };
      const next = { ...prev, [id]: { ...base, ...patch } };
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => saveAll(next), 800);
      return next;
    });
  };

  return { markupMode, setMarkupMode, labels, setLabel, savedAt };
}
